import { getStaticCacheControl } from '@/routes-utils/get-static-cache-control';
import { SeoHandle } from '../sitemap[.]xml/generate-sitemap';

export const headers = () => getStaticCacheControl();

export const handle: SeoHandle = {
  sitemap: true,
};

export default function Terms() {
  return (
    <object
      data={'https://media.synoptic.com/service/terms/terms.pdf'}
      type="application/pdf"
      width="100%"
      height="100%"
    />
  );
}
